import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchPredesTransactionsObject = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'objectPredesTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    comments: payload.params.comments,
    quantity: payload.params.quantity,
    transactionId: payload.params.transactionId,
  });
};

export default apiFetchPredesTransactionsObject;
